/*
 * Padding for the pills in the profile links row. They sit a step below the
 * Button `small` size so the row reads lighter than the Follow button. Link,
 * Support and Germ DM pills all share these.
 */
export const PILL_VERTICAL = 6
export const PILL_LEFT = 10
/** Right edge when the pill ends in the outbound arrow. */
export const PILL_RIGHT_ARROW = 10
/** Right edge when the pill ends in the editor's drag grip. */
export const PILL_RIGHT_GRIP = 8
/** Right edge when the pill ends in plain text. */
export const PILL_RIGHT_TEXT = 12
